import { render, staticRenderFns } from "./SuggestedEnhancement.vue?vue&type=template&id=42dda9b0&scoped=true&"
import script from "./SuggestedEnhancement.vue?vue&type=script&lang=js&"
export * from "./SuggestedEnhancement.vue?vue&type=script&lang=js&"
import style0 from "./SuggestedEnhancement.vue?vue&type=style&index=0&id=42dda9b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42dda9b0",
  null
  
)

export default component.exports